export default __webpack_public_path__ + "static/media/12.35ad2736.webp";